exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-wrapper[data-v-335b5766]{position:fixed;top:8rem;left:0;right:0;bottom:0}", ""]);

// exports
